export default {
  badge: {
    id: 'buyback_offer_v2_reassurance_badge',
    defaultMessage: 'Highest offer guaranteed',
  },
  truck: {
    id: 'buyback_offer_v2_reassurance_truck',
    defaultMessage: 'Free & insured shipping',
  },
  money: {
    id: 'buyback_offer_v2_reassurance_money',
    defaultMessage: 'Fast cash payment',
  },
}
